/*
 * Quick size picker on product cards (snippets/t4m-quick-sizes.liquid).
 * A size button adds that variant to the cart through the same flow as
 * product-form.js, so the cart drawer, cart bubble and cart apps update as usual.
 * On touch screens the "+" opens the sizes in a bottom sheet instead of over
 * the card, so the picker never hides the product name and price.
 * Delegated on document: survives facets/"Carregar mais" re-rendering the grid.
 */
(function () {
  'use strict';

  if (window.__t4mQuickSizesBound) return;
  window.__t4mQuickSizesBound = true;

  var OK_MS = 1600;
  var SHEET_MS = 280;
  var touchQuery = window.matchMedia('(hover: none)');
  var sheet = null;

  function closeSheet(restoreFocus) {
    if (!sheet) return;
    var old = sheet;
    sheet = null;
    old.classList.remove('is-open');
    if (old._toggle) {
      old._toggle.setAttribute('aria-expanded', 'false');
      if (restoreFocus) old._toggle.focus({ preventScroll: true });
    }
    setTimeout(function () { old.remove(); }, SHEET_MS);
  }

  function closeAll(except) {
    if (sheet && sheet !== except) closeSheet(false);
    document.querySelectorAll('[data-t4m-qs].is-open').forEach(function (qs) {
      if (qs === except) return;
      qs.classList.remove('is-open');
      var toggle = qs.querySelector('[data-t4m-qs-toggle]');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    });
  }

  function openSheet(qs, toggle) {
    closeAll(null);
    var panel = qs.querySelector('.t4m-qs__panel');
    if (!panel) return;
    var title = qs.getAttribute('data-title') || '';
    var el = document.createElement('div');
    el.className = 't4m-qs-sheet';
    el.setAttribute('data-t4m-qs', '');
    el.setAttribute('data-adding', qs.getAttribute('data-adding') || '');
    el.innerHTML =
      '<div class="t4m-qs-sheet__backdrop" data-t4m-qs-close></div>' +
      '<div class="t4m-qs-sheet__body" role="dialog" aria-modal="true">' +
      '<div class="t4m-qs-sheet__head"><p class="t4m-qs-sheet__title"></p>' +
      '<button type="button" class="t4m-qs-sheet__close" data-t4m-qs-close>' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>' +
      '</button></div></div>';
    el.querySelector('.t4m-qs-sheet__title').textContent = title;
    el.querySelector('.t4m-qs-sheet__body').setAttribute('aria-label', title);
    el.querySelector('.t4m-qs-sheet__close').setAttribute('aria-label', qs.getAttribute('data-close') || 'Fechar');
    var body = el.querySelector('.t4m-qs-sheet__body');
    Array.prototype.forEach.call(panel.children, function (child) {
      body.appendChild(child.cloneNode(true));
    });
    el._toggle = toggle;
    document.body.appendChild(el);
    sheet = el;
    toggle.setAttribute('aria-expanded', 'true');
    requestAnimationFrame(function () {
      el.classList.add('is-open');
      var first = el.querySelector('.t4m-qs__size:not([disabled])');
      if (first) first.focus({ preventScroll: true });
    });
  }

  function setMessage(qs, text) {
    var msg = qs.querySelector('.t4m-qs__msg');
    if (msg) msg.textContent = text || '';
  }

  function publishEvent(name, data) {
    if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) window.publish(window.PUB_SUB_EVENTS[name], data);
  }

  function add(button) {
    var qs = button.closest('[data-t4m-qs]');
    if (!qs || button.disabled || qs.getAttribute('aria-busy') === 'true') return;
    var cart = document.querySelector('cart-drawer');
    var routes = window.routes || {};
    var variantId = button.getAttribute('data-variant-id');
    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');
    if (cart && typeof cart.getSectionsToRender === 'function') {
      formData.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
      formData.append('sections_url', window.location.pathname);
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(button);
    }

    // Immediate feedback so the tap never feels ignored while the cart request runs.
    qs.setAttribute('aria-busy', 'true');
    button.classList.add('is-loading');
    setMessage(qs, qs.getAttribute('data-adding') || '');

    fetch(routes.cart_add_url || '/cart/add', {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    })
      .then(function (r) { return r.json(); })
      .then(function (response) {
        if (response.status) {
          publishEvent('cartError', { source: 't4m-quick-sizes', productVariantId: variantId, errors: response.errors || response.description, message: response.message });
          setMessage(qs, response.description || response.message || '');
          return;
        }
        if (!cart) {
          window.location = routes.cart_url || '/cart';
          return;
        }
        setMessage(qs, '');
        publishEvent('cartUpdate', { source: 't4m-quick-sizes', productVariantId: variantId, cartData: response });
        button.classList.add('is-ok');
        setTimeout(function () { button.classList.remove('is-ok'); }, OK_MS);
        closeAll(null);
        cart.renderContents(response);
        cart.classList.remove('is-empty');
      })
      .catch(function (error) {
        setMessage(qs, '');
        console.error('[t4m-quick-sizes]', error);
      })
      .finally(function () {
        qs.removeAttribute('aria-busy');
        button.classList.remove('is-loading');
      });
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-t4m-qs-toggle]');
    if (toggle) {
      e.preventDefault();
      var qs = toggle.closest('[data-t4m-qs]');
      if (touchQuery.matches) {
        openSheet(qs, toggle);
        return;
      }
      var willOpen = !qs.classList.contains('is-open');
      closeAll(qs);
      qs.classList.toggle('is-open', willOpen);
      toggle.setAttribute('aria-expanded', String(willOpen));
      if (willOpen) {
        var first = qs.querySelector('.t4m-qs__size:not([disabled])');
        if (first) first.focus({ preventScroll: true });
      }
      return;
    }
    if (e.target.closest('[data-t4m-qs-close]')) {
      e.preventDefault();
      closeSheet(true);
      return;
    }
    var size = e.target.closest('.t4m-qs__size');
    if (size) {
      e.preventDefault();
      add(size);
      return;
    }
    if (!e.target.closest('[data-t4m-qs]')) closeAll(null);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (sheet) {
      closeSheet(true);
      return;
    }
    var open = document.querySelector('[data-t4m-qs].is-open');
    if (!open) return;
    closeAll(null);
    var toggle = open.querySelector('[data-t4m-qs-toggle]');
    if (toggle) toggle.focus();
  });
})();
